<template>
	<div>
    <div class="container is-max-desktop p-5">
      <LoginHeader/>
      <div class="columns">
          <div class="column">
            <div class="content has-text-left">
              <h3 v-html="$t('login_intro_header')"></h3>
              <p>{{$t('login_intro_text')}}</p>
              
              <router-link to="/consultOurExperts" custom v-slot="{ navigate }">
                <b-button type="is-primary" outlined @click="navigate" role="link">{{$t('consult_our_experts')}}</b-button>
              </router-link>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <p class="card-header-title pl-5">
                {{$t('login')}}
              </p>
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <div class="card-content has-text-left">
                <ValidationProvider rules="requiredEmail|validEmail" v-slot="{ errors }">
                <b-field :label="labels.email.show?$t('email'):''" :label-position="labels.email.position" class="mb-5"
                  :type="{'is-danger':errors[0]}"
                  :message="[$t(errors[0])]">
                    <b-input :placeholder="$t('email')+'*'" @keyup.enter.native="handleSubmit(loginF)" v-model.trim="loginForm.email" @focus="focusInput('email')" @blur="blurInput('email')"></b-input>                  
                </b-field>
                </ValidationProvider>
                <ValidationProvider rules="requiredPassword" v-slot="{ errors }">
                <b-field :label="labels.password.show?$t('password'):''" :label-position="labels.password.position" class="mb-5"
                  :type="{'is-danger':errors[0]}"
                  :message="[$t(errors[0])]">
                    <b-input type="password" @keyup.enter.native="handleSubmit(loginF)" :placeholder="$t('password')+'*'" v-model="loginForm.password" password-reveal @focus="focusInput('password')" @blur="blurInput('password')"></b-input>
                </b-field>
                </ValidationProvider>
                <div class="columns">
                  <div class="column is-flex is-align-items-center is-justify-content-space-between">
                    <b-button type="is-primary" @click="handleSubmit(loginF)">{{$t('do_login')}}</b-button>
                  
                    <router-link to="/forgotPassword" custom v-slot="{ navigate }">
                      <a @click="navigate" role="link">{{$t('forgot_password')}}</a>
                    </router-link>
                  </div>
                </div>  
              </div>
              </ValidationObserver>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import LoginHeader from './LoginHeader';

extend('requiredEmail', {
  ...required,
  message: 'email_is_required'
});

extend('validEmail',{
  ...email,
  message : 'please_enter_a_valid_email'
});

extend('requiredPassword', {
  ...required,
  message: 'password_is_required'
});



export default {
  name: 'Login',
  components: {
    LoginHeader,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      
      loginForm:{
        email:'',
        password:''
      },
      labels:{
        email:{position:'',show:false},
        password:{position:'',show:false}
      },
      twofaActivated:"",
    }
  },
  methods: {
    ...mapActions(['authenticateUser_2fa']),
    focusInput(val){
      this.labels[val].position='on-border'
      this.labels[val].show=true
    },
    blurInput(val){
      if(this.loginForm[val]==''){
        this.labels[val].show=false
      }
    },
    loginF(){
      this.authenticateUser_2fa(this.loginForm).then((response) => {
          console.log('--authenticateUser_2fa success response')
          console.log(response)
          if(response.status.code == '0'){
            this.twofaActivated=response.content.twofa_activated
            console.log(this.twofaActivated);
            localStorage.setItem("twofaActivated",JSON.stringify(this.twofaActivated));
            localStorage.setItem("loginData",JSON.stringify(this.loginForm));
            this.$moment.locale(response.content.language)
            this.$i18n.locale = response.content.language
            this.$router.push('/loginTwoFactor')
            // this.$refs.Login.initialize_2faF(this.loginForm)
          
          }
      }).catch(e => {
          console.log('--authenticateUser_2fa Error')
          console.log(e)
      })
    },

  },
  created(){
    this.$root.$refs.Login= this
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/Login.vue